const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetch wrapper that automatically refreshes JWT token on 401.
 * Use this instead of raw fetch() for authenticated API calls.
 */
export async function authFetch(url, options = {}) {
  const res = await fetch(url, { ...options, credentials: "include" });

  if (res.status === 401 && !url.includes("/auth/")) {
    // Try to refresh the token
    try {
      const refreshRes = await fetch(`${API}/api/auth/refresh`, {
        method: "POST",
        credentials: "include",
      });
      if (refreshRes.ok) {
        // Retry the original request
        return fetch(url, { ...options, credentials: "include" });
      }
    } catch {
      // Refresh failed — return original 401
    }
  }

  return res;
}
